<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
        color="blue accent-3"
        dark
        extended
        flat
        class="toolbar__fixed"
      >
      </v-toolbar>
      <v-card flat
              class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <h4 v-if="fixace!=null">Fixace ke dni {{ fixace.datum | formatDate }}</h4>

            <v-toolbar color="transparent" class="elevation-0">
              <h2>Platby</h2>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-switch label="Zobrazit detaily" v-model="platbyDetail" class="ml-3 mt-3"></v-switch>
              </v-toolbar-items>
            </v-toolbar>
            <v-layout row wrap class="mb-2 mx-2 pl-1">
              <v-flex xs12>
                Počet plateb: {{ platbyItems.length }}
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="platbyHeaders"
              :items="platbyItems"
              :loading="platbyLoading"
              hide-actions
              class="mt-3 elevation-2 ml-2 mr-2 table-top-border table-no-white-space"
              v-if="!platbyLoading"
              :expand="true"
              ref="platbyTable"
            >
              <template slot="items" slot-scope="props">
                <tr class="transparent">
                  <td>
                    <v-checkbox
                      v-model="props.item.zpracovat"
                      primary
                      hide-details
                      @change="zpracovatPlatbu(props.item)"
                      v-if="!props.item.saving"
                      disabled
                    ></v-checkbox>
                    <v-progress-circular indeterminate v-else size="20" color="blue"></v-progress-circular>
                  </td>
                  <td class="pt-3 pb-3 subheading">{{ props.item.id }}</td>
                  <td class="pt-3 pb-3 subheading">{{ props.item.datum | formatDate }}</td>
                  <td class="pt-3 pb-3 subheading">
                    <router-link v-if="props.item.osoba!=null" :to="{ path: '/klienti/' + props.item.osoba.id }"
                                 target="_blank">
                      {{ props.item.osoba.nazev_osoby }}
                    </router-link>
                  </td>
                  <td class="pt-3 pb-3 subheading">
                    <span v-if="props.item.ucel_platby=='sporeni'">Spoření</span>
                    <span v-else-if="props.item.ucel_platby=='jednorazovy_nakup'">Jednorázový nákup</span>
                    <span v-else-if="props.item.ucel_platby=='elektronicka_penezenka'">Elektronická peněženka</span>
                  </td>
                  <td class="pt-3 pb-3 subheading">{{ props.item.variabilni_symbol }}</td>
                  <td class="pt-3 pb-3 subheading">{{ props.item.protiucet }}</td>
                  <td class="pt-3 pb-3 subheading text-xs-right">
                    {{ props.item.castka | formatMoney }}{{ props.item.mena.zkratka }}
                  </td>
                  <td class="pt-3 pb-3 subheading">{{ props.item.poznamka }}</td>
                  <td class="pt-3 pb-3 subheading">
                    <router-link :to="{ path: '/klienti/' + props.item.osoba.id + '/sporici-programy' }" target="_blank"
                                 v-if="props.item.osoba!=null && props.item.ucel_platby=='sporeni'">
                      {{ props.item.sporici_program.nazev_sporeni }}
                    </router-link>
                  </td>
                  <td class="pt-3 pb-3 subheading">
                    <router-link :to="{ path: '/klienti/' + props.item.osoba.id + '/sporici-programy' }" target="_blank"
                                 v-if="props.item.osoba!=null && props.item.ucel_platby=='sporeni'">
                      {{ props.item.sporici_program.cilovy_produkt.nazev }}
                    </router-link>
                  </td>
                  <td class="pt-3 pb-3 pr-5 subheading text-xs-right"><span
                    v-if="props.item.konto_pohyb>0">{{ props.item.konto_pohyb | formatMoney }} g</span><span
                    v-else>---</span></td>
                </tr>
              </template>
              <template slot="expand" slot-scope="props">
                <v-card class="grey lighten-4 mt-1 ml-4 mb-4 mr-4 intersect no__radius" v-if="props.item.zpracovat">
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm6>
                        <div :class="{ 'mr-4': $vuetify.breakpoint.smAndUp }">
                          <h4 class="ml-3 mt-2">Pohyby na elektronické peněžence:</h4>
                          <v-data-table
                            :headers="platbyPenezenkaHeaders"
                            :items="props.item.elektronicka_penezenka"
                            hide-actions
                            class="mt-2 transparent--table"
                            hide-headers
                          >
                            <template slot="items" slot-scope="props">
                              <tr class="transparent">
                                <td class="pl-3 subheading">{{ props.item.popis }}</td>
                                <td class="subheading text-xs-right">{{ props.item.castka | formatMoney }}
                                  {{ props.item.mena.zkratka }}
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </div>
                      </v-flex>
                      <v-flex xs12 sm6
                              v-if="props.item.ucel_platby=='sporeni' || props.item.ucel_platby=='jednorazovy_nakup'">
                        <div :class="{ 'ml-4': $vuetify.breakpoint.smAndUp }">
                          <h4 class="ml-3 mt-2">Provize spolupracovníkům:</h4>
                          <v-data-table
                            :headers="platbyProvizeHeaders"
                            :items="props.item.provize"
                            hide-actions
                            class="mt-2 transparent--table"
                            hide-headers
                          >
                            <template slot="items" slot-scope="props">
                              <tr class="transparent">
                                <td class="pl-3 subheading">
                                  <router-link :to="{ path: '/spolupracovnici/' + props.item.spolupracovnik.id }"
                                               target="_blank">
                                    {{ props.item.spolupracovnik.nazev_osoby }}
                                  </router-link>
                                </td>
                                <td class="subheading text-xs-right"><span
                                  v-if="!props.item.tipar">Pozice: {{ props.item.pozice }}</span><span
                                  v-else>Tipař</span><span v-if="props.item.ma_kancelar">, Kancelář</span></td>
                                <td class="subheading text-xs-right">{{ props.item.kredity | formatMoney }} kr.</td>
                                <td class="subheading text-xs-right">{{ props.item.castka | formatMoney }} Kč</td>
                              </tr>
                            </template>
                          </v-data-table>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
                <v-card class="grey lighten-4 mt-1 ml-4 mb-4 mr-4 intersect no__radius" v-else>
                  <v-card-text>
                    <p class="ma-2 subheading red--text darken-3">Platba nebyla zpracována v této fixaci.</p>
                  </v-card-text>
                </v-card>
              </template>
            </v-data-table>

            <h3 class="ml-2 mr-2 mt-5">Souhrn spoření</h3>
            <div class="summary__wrapper">
              <v-alert
                v-if="souctyError"
                type="error"
                outline
                class="ml-4 mr-4 mt-2"
              >{{ souctyError }}
              </v-alert>

              <v-skeleton-loader
                v-if="souctyLoading"
                type="table"
                class="ml-4 mr-4 mt-2"
              />

              <v-data-table
                v-else
                :headers="[
      { text:'Kov', value:'kov' },
      { text:'Součet', value:'soucet', align: 'right' }
    ]"
                :items="[
      { kov:'Zlato',   soucet: souctySporeni.zlato },
      { kov:'Stříbro', soucet: souctySporeni.stribro }
    ]"
                hide-actions
                class="mt-2 elevation-2 ml-2 mr-2"
              >
                <template v-slot:items="props">
                  <td>{{ props.item.kov }}</td>
                  <td class="text-xs-right">{{ formatCZK(props.item.soucet) }}</td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'

export default {
  extends: Base,
  data() {
    return {
      dialog: false,
      e1: 1,
      loading: true,
      fixace: null,
      kurzyHeaders: [
        {text: 'Název měny', value: 'nazev'},
        {text: 'Zkratka', value: 'zkratka'},
        {text: 'URL kurzu', value: 'url_kurzu'},
        {text: 'Kurz', value: 'aktualni_kurz'}
      ],
      kurzyItems: [],
      kurzyLoading: false,
      aktualni_stav: "",
      problem: null,
      slitkyHeaders: [],
      slitkyItems: [],
      komodityHeaders: [
        {text: 'Název kovu', value: 'nazev'},
        {text: 'Cena', value: 'cena', width: "300px"}
      ],
      komodityItems: [],
      platbyHeaders: [
        {text: '', value: 'id', sortable: false},
        {text: 'ID', value: 'id', sortable: false},
        {text: 'Datum', value: 'datum', sortable: false},
        {text: 'Osoba', value: 'osoba.nazev_osoby', sortable: false},
        {text: 'Účel platby', value: 'ucel_platby', sortable: false},
        {text: 'Variabilní symbol', value: 'variabilni_symbol', sortable: false},
        {text: 'Protiúčet', value: 'protiucet', sortable: false},
        {text: 'Částka', value: 'castka', align: 'right', sortable: false, width: '150px'},
        {text: 'Poznámka', value: 'poznamka', sortable: false},
        {text: 'Spořící program', value: 'sporici_program.nazev_sporeni', sortable: false},
        {text: 'Cílový produkt', value: 'sporici_program.cilovy_produkt.nazev', sortable: false},
        {text: 'Pohyb sp. konta', value: 'konto_pohyb', sortable: false},
      ],
      platbyItems: [],
      platbyPenezenkaHeaders: [
        {text: 'Popis', value: 'popis', sortable: false},
        {text: 'Částka', value: 'castka', align: 'right', sortable: false}
      ],
      platbyProvizeHeaders: [
        {text: 'Spolupracovník', value: 'spolupracovnik.nazev_osoby', sortable: false},
        {text: 'Pozice', value: 'pozice', sortable: false},
        {text: 'Kredity', value: 'kredity', align: 'right', sortable: false},
        {text: 'Částka', value: 'castka', align: 'right', sortable: false}
      ],
      komodityLoading: false,
      produktyLoading: false,
      platbyLoading: false,
      platbyDetail: true,
      souctySporeni: { zlato: 0, stribro: 0 },
      souctyLoading: false,
      souctyError: null,
    }
  },
  props: {
    id: String
  },
  watch: {
    platbyDetail(v) {
      for (let i = 0; i < this.platbyItems.length; i += 1) {
        const item = this.platbyItems[i];
        this.$set(this.$refs.platbyTable.expanded, item.id, v);
      }
    }
  },
  mounted: function () {
    window.MenuListener.show();
    this.loadFixace();
    this.fetchSouctySporeni(this.id);
  },
  methods: {
    loadFixace() {
      this.loading = true;
      window.API.get("fixace/" + this.$props.id).then((b) => {
        this.fixace = b;
        this.platbyItems = b.platby;
        this.loading = false;
        this.$nextTick(() => {
          for (let i = 0; i < this.platbyItems.length; i += 1) {
            const item = this.platbyItems[i];
            this.$set(this.$refs.platbyTable.expanded, item.id, true);
          }
        });
      }).catch((e) => {
        console.log(e);
      })
    },
    async fetchSouctySporeni(fixaceId) {
      this.souctyLoading = true;
      this.souctyError = null;
      try {
        let url = `fixace/${fixaceId}/soucty-sporeni`;
        const resp = await window.API.get(url);
        this.souctySporeni = Object.assign({ zlato: 0, stribro: 0 }, resp || {});
      } catch (e) {
        console.error(e);
        this.souctyError = "Nepodařilo se načíst součty spoření.";
        this.souctySporeni = { zlato: 0, stribro: 0 };
      } finally {
        this.souctyLoading = false;
      }
    },

    formatCZK(v) {
      if (typeof v !== "number") v = Number(v) || 0;
      return new Intl.NumberFormat("cs-CZ", {
        style: "currency",
        currency: "CZK",
        maximumFractionDigits: 2
      }).format(v);
    },
  },
  components: {}
}
</script>



// WEBPACK FOOTER //
// src/pages/Fixace/FixaceDetail.vue